import createAction from "../../redux/createAction";
import lpActions from "./lpActionTypes";
export var storeAuthorizedLpsAction = createAction(lpActions.SET_AUTHORIZED_LPS);
export var storeAuthorizedDSPsAction = createAction(lpActions.SET_AUTHORIZED_DSPS);
export var storeAuthorizedEntitiesAction = createAction(lpActions.SET_AUTHORIZED_ENTITIES);
export var storeAuthorizedLpSelectedAction = createAction(lpActions.SET_SELECTED_LP);

//# sourceMappingURL=actions.js.map